module.exports = __webpack_public_path__ + "media/bootstrap-icons/eraser-297bfadb.svg";